/**
 * Gemini CLI config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client) + ~/.gemini/skills/
 * MCP: ~/.gemini/settings.json mcpServers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { copySkillTo, removeSkillFrom, installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const GEMINI_SKILLS_DIR = join(homedir(), ".gemini", "skills");
const GEMINI_CONFIG = join(homedir(), ".gemini", "settings.json");

export const gemini: AgentConfigWriter = {
  id: "gemini",
  name: "Gemini CLI",

  installSkill(global: boolean) {
    installCrossClientSkill(global);
    copySkillTo(GEMINI_SKILLS_DIR);
  },

  installMcp() {
    mutateJsonFile(GEMINI_CONFIG, (config) => {
      if (!config.mcpServers) config.mcpServers = {};
      config.mcpServers[MCP_SERVER_NAME] = buildMcpEntry();
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
    removeSkillFrom(GEMINI_SKILLS_DIR);
  },

  uninstallMcp() {
    mutateJsonFile(GEMINI_CONFIG, (config) => {
      if (config.mcpServers?.[MCP_SERVER_NAME]) {
        delete config.mcpServers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
